/// <reference path="ChartSetupProxy.js"/>
/// <reference path="ChartSetupDataBinding.js"/>
/// <reference path="../LayoutControls.js"/>
/// <reference path="ChartSetupSelections.js" />

window.ChartSetupDataCom = function () {
    function validateSelections(dataGroups) {
        var errMsg = '', i = dataGroups.length, dataGroup;
        var contentType = ChartSetupDataBinding.GetBoundContentType();

        while (i--) {
            dataGroup = dataGroups[i];
            if (dataGroup.questionSelections.questions.length == 0)
                errMsg += dataGroup.groupName + ': ' + 'Please select at least one question';
            else if (dataGroup.calculationType <= 2 && dataGroup.questionSelections.answers.length == 0)
				errMsg += dataGroup.groupName + ': ' + 'Please select at least one answer';

			if (ProjectHasPercentileRefData && dataGroup.referenceDataSettings.isEnabled && dataGroup.referenceDataSettings.resultType > 0 &&
				dataGroup.referenceDataSettings.resultType != 4 && dataGroup.referenceDataSettings.percentile == null)
				errMsg += dataGroup.groupName + ': ' + 'Please enter valid reference data percentile';

            if (dataGroup.calculationType == Storyboard.Constants.CalculationTypes.CORRELATION_ANALYSIS &&
                dataGroup.correlationSettings.questionId < 1)
                errMsg += dataGroup.groupName + ': ' + 'Please select a question to test against';

            if (!dataGroup.axisOptions.autoGrid && dataGroup.axisOptions.gridInterval == 0 && contentType != Storyboard.Constants.itemTypes.SIMPLETABLE)
                errMsg += dataGroup.groupName + ': ' + 'Please enter a scale step greater than zero';
            
            var legendItems = $.grep(dataGroup.groupedItems, function (e) {
                return e.position == Storyboard.Constants.Axis.legend;
            });
            if (dataGroup.usePercentile && legendItems.length < 1)
                errMsg += dataGroup.groupName + ": " + 'Please add at least one item to legend: required by percentile';
                 
            if (!dataGroup.nestFilterCompares && 
                dataGroup.groupedItems.filter(function(group) {
                    return group.groupType === Storyboard.Constants.GroupTypes.FILTER && group.position == 1; 
                }).length > 1 &&
                dataGroup.groupedItems.filter(function(group) {
                    return group.groupType === Storyboard.Constants.GroupTypes.FILTER && group.position == 2; 
                }).length > 1) {
                    if (contentType === Storyboard.Constants.itemTypes.CHART)
                        errMsg += 'When the "Nest Compare Filters" setting is turned off you can only have multiple filters in either axis or legend!';
                    else if (contentType === Storyboard.Constants.itemTypes.SIMPLETABLE)
                        errMsg += 'When the "Nest Compare Filters" setting is turned off you can only have multiple filters in either rows or columns!';
                }

            if (dataGroup.seriesSettings.seriesStripSettings.seriesStripType == 8 && dataGroup.seriesSettings.showTopSeriesOrientation == 3) {
                var showTopSeries = Number(dataGroup.seriesSettings.showTopSeries);
                var showTopSeriesTo = Number(dataGroup.seriesSettings.showTopSeriesTo);
                if (isNaN(showTopSeries) || isNaN(showTopSeries) || showTopSeries <= 0 || showTopSeriesTo <= 0 || showTopSeries > showTopSeriesTo) {
                    errMsg += 'Invalid range!';
                }
            }
        }

        if (dataGroups.length == 0)
            errMsg = 'Please define chart settings';

        if (errMsg)
            Storyboard.LayoutControls.showError(errMsg);
        return !errMsg;
    }

    return {
    	SaveDataGroups: function (dataGroupList, deletedGroups, layoutElementItem, callback) {
    		$(dataGroupList).each(function () { Storyboard.DataGroupLogic.fixDatesForTimezone(this); });
            validateSelections(dataGroupList) && ChartSetupProxy.SaveDataGroups(dataGroupList, deletedGroups, layoutElementItem, callback);
        },
    	RHSaveDataGroups: function (dataGroupList, guid, callback) {
    		$(dataGroupList).each(function () { Storyboard.DataGroupLogic.fixDatesForTimezone(this); });
            validateSelections(dataGroupList) && ChartSetupProxy.RHSaveDataGroups(dataGroupList, guid, callback);
        },
        GetPreviewChart: function (dataGroups, genSettings, elementItem, styles, columnToSortBy, sortDirection) {
        	$(dataGroups).each(function () { Storyboard.DataGroupLogic.fixDatesForTimezone(this); });
            if (validateSelections(dataGroups)) {
                var params = {
                    dataGroups: dataGroups,
                    generalSettings: genSettings,
                    elementItem: elementItem,
                    styles: styles,
                    columnToSortBy: columnToSortBy,
                    sortDirection: sortDirection
                };
                var message = elementItem.itemType === Storyboard.Constants.itemTypes.SIMPLETABLE ? "Rendering simple table preview" : "Rendering chart preview";
                ChartSetupProxy.GetPreviewChart(params, message, function (chartData) {
                    ChartSetupDataBinding.RenderChartData(chartData, elementItem.itemType);
                });
            }
        },
        LoadThemesList: function (howMany) {
            ChartSetupProxy.GetChartThemes(howMany, ChartSetupDataBinding.BindThemesList);
        },
        FilterCorrelationQuestions: function () {
        	var filter = $("#txtCorrelationQuestion").val();
        	var questionBlocks = "";
        	var variableSubsets = "";
        	var gridQuestions = "";

            ChartSetupProxy.GetFilterQuestions(filter, Storyboard.Constants.CalculationTypes.CORRELATION_ANALYSIS, questionBlocks, variableSubsets, gridQuestions, false,
                "", 0, false, ChartSetupDataBinding.BindCorrelationQuestions);
        },
        FilterQuestions: function () {
            var filter = $('#txtQuestion').val();
			var calculationType = $("#ddlCalculationType").val() || "";
            var questionBlocks = $('#lbQB').val() || "";
            var variableSubsets = $('#lbVS').val() || "";
            var gridQuestions = $('#lbGQ').val() || "";
            var filterByCode = $("#chbShowQuestionCode").attr("checked");

            ChartSetupProxy.GetFilterQuestions(filter, calculationType, questionBlocks, variableSubsets, gridQuestions, filterByCode, "", 0, false, ChartSetupDataBinding.BindQuestions);
        },
        FilterAnswers: function () {
            var selections = {
            	selectedQuestions: ChartSetupUIObj.GetSelectedQuestions(),
                filter: $('#txtAnswer').val(),
                variableSubsets: $('#lbVS').val() || "",
                calculationType: $("#ddlCalculationType").val() || "",
                filterByRowNo: $("#chbShowAnswerId").attr("checked")
            };
            ChartSetupProxy.GetAnswers(selections, ChartSetupDataBinding.BindAnswers);
        },
        BindDataGroup: function (dataGroup, layoutElement, contentElement) {

            var contentType = contentElement.itemType;
            /* fetch and bind questions and answers for the datagroup that will be bound */
            ChartSetupProxy.GetFilterSelectedQuestions('', dataGroup, false, function (questions) {
                ChartSetupProxy.GetSelectedAnswers('', dataGroup, false, function (answers) {
                    if (layoutElement.templateId != null && Storyboard.LayoutDesigner.isAdmin)
                        ChartSetupProxy.GetTemplateData(dataGroup.templateDataGroupId, layoutElement.templateId, function (data) {
                            ChartSetupDataBinding.BindTemplateData(data);
                        });
                    DataGroupSelections.ShowHideFilterPanel(dataGroup.questionSelections.questionBlocks, "#qbFilterPanel", "#chkQB");
                    ChartSetupDataBinding.BindQuestions(questions, false, dataGroup.questionSelections.questions);
            		ChartSetupDataBinding.BindSelectedAnswers(answers,
						dataGroup.questionSelections.allAnswers ? "all" : dataGroup.questionSelections.answers, dataGroup.calculationType);
            		ChartSetupDataBinding.BindLoadedGroup(dataGroup, contentType);
            		$(document).trigger('DAPI.QuestionsAndAnswersFetched'); // #38649 - Wrong variables selected during load
            	});
            });

            $("#divChart, #divTable").width(contentElement.width).height(contentElement.height);

            $('#ddlSeriesType span > option').unwrap();
            DataGroupSelections.HideGuiElementsByType(dataGroup.seriesSettings.seriesType, dataGroup, contentType);
        },
        LoadScatterOptions: function (dataGroups, callback) {
        	$(dataGroups).each(function () { Storyboard.DataGroupLogic.fixDatesForTimezone(this); });
            ChartSetupProxy.LoadScatterOptions(dataGroups, callback);
        },
        GetChartData: function (args) {
            if ((args.status & Storyboard.Constants.ChartFlags.CODE_NODATA) === Storyboard.Constants.ChartFlags.CODE_NODATA)
                args.chartOptions = "nodata";
            else if ((args.status & Storyboard.Constants.ChartFlags.CODE_NOTPRELOADED) === Storyboard.Constants.ChartFlags.CODE_NOTPRELOADED)
                args.chartOptions = "notpreloaded";
            else
                args.chartOptions = args.chartOptions || {};

            return args;
        }
    };
}();
